<template>
    <div class="bento-container">
        <!-- Page Header -->
        <div class="bento-header">
            <div class="header-content">
                <div class="header-icon">
                    <i class="el-icon-chat-line-round"></i>
                </div>
                <div class="header-text">
                    <h2>评论管理</h2>
                    <p>课程评论审核 · 用户反馈管理</p>
                </div>
            </div>
            <div class="header-actions">
                <div class="header-search">
                    <div class="search-input-wrapper">
                        <i class="el-icon-search input-icon"></i>
                        <el-input v-model="formDatas.courseTitle" placeholder="搜索课程名称" clearable size="medium"
                            class="ai-input" @keyup.enter.native="partserch"></el-input>
                    </div>
                </div>
                <el-button class="ai-btn" @click="() => { formDatas.currentPage = 1; partserch() }">
                    <i class="el-icon-search"></i>
                    搜索
                </el-button>
            </div>
        </div>

        <!-- Bento Grid Layout -->
        <div class="bento-grid">
            <!-- Data Table Card - Full Width -->
            <div class="bento-card table-card full">
                <div class="card-header">
                    <span class="card-title">
                        <i class="el-icon-notebook-2"></i>
                        评论列表
                    </span>
                    <div class="card-actions">
                        <span class="ai-hint">
                            <i class="el-icon-info"></i>
                            支持课程名称筛选
                        </span>
                    </div>
                </div>
                <div class="card-content">
                    <aj-table ref="ajTable" :data="tableData" :columns="tableColumns" :editable="tableEditable"
                        :use-internal-pagination="true" :currentPage.sync="formDatas.currentPage" :height="tableHeight"
                        :pageSize.sync="formDatas.pageSize" :total="totalCount" row-id-key="courseCommentId" stripe
                        @page-change="handlePageChange"
                        @operate-btn-click="handleOperateBtnClick">
                        <!-- 自定义单元格插槽 - 课程名称 -->
                        <template #cell-courseTitle="{ row }">
                            <span style="color:#409EFF; cursor: pointer;" @click="handleCourseClick(row)">
                                {{ row.courseTitle || '-' }}
                            </span>
                        </template>
                        <!-- 自定义单元格插槽 - 评论内容 -->
                        <template #cell-content="{ row }">
                            <el-tooltip :content="row.content" placement="top" :disabled="!row.content || row.content.length <= 50">
                                <span class="comment-content">{{ row.content || '-' }}</span>
                            </el-tooltip>
                        </template>
                        <!-- 自定义单元格插槽 - 子评论数 -->
                        <template #cell-courseCommentChildNums="{ row }">
                            <span v-if="row.courseCommentChildNums > 0" class="child-count" @click="viewChildComments(row)">
                                <i class="el-icon-chat-dot-square"></i>
                                {{ row.courseCommentChildNums }} 条回复
                            </span>
                            <span v-else class="no-child">-</span>
                        </template>
                        <!-- 自定义单元格插槽 - 评论时间 -->
                        <template #cell-createtime="{ row }">
                            {{ formatTime(row.createtime) }}
                        </template>
                    </aj-table>
                </div>
            </div>
        </div>

        <!-- 子评论查看弹窗 -->
        <el-dialog title="子评论" :visible.sync="childCommentDialogVisible" width="800px" :close-on-click-modal="false">
            <div v-if="currentParentComment" class="parent-comment">
                <div class="parent-label">父评论：</div>
                <div class="parent-content">{{ currentParentComment.content }}</div>
            </div>
            <el-table :data="childComments" border stripe height="400">
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="userName" label="评论用户" min-width="100" align="center"></el-table-column>
                <el-table-column prop="content" label="评论内容" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createtime" label="评论时间" min-width="160" align="center">
                    <template slot-scope="scope">
                        {{ formatTime(scope.row.createtime) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" style="color: #F56C6C" @click="deleteComment(scope.row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import {
    getAjCourseCommentListOperation,
    deleteAjCourseComment,
    getAjCourseCommentList
} from "../../api/api";

export default {
    name: "commentManagement",
    data() {
        return {
            tableHeight: 400,
            childCommentDialogVisible: false,
            currentParentComment: null,
            childComments: [],
            tableData: [],
            tableColumns: [
                { type: 'index', label: '序号', width: 80, fixed: 'left', align: 'center' },
                { label: '课程名称', prop: 'courseTitle', width: 180, align: 'center', slot: 'courseTitle' },
                { label: '评论用户', prop: 'userName', width: 120, align: 'center' },
                { label: '评论内容', prop: 'content',  align: 'center', slot: 'content' },
                { label: '子评论数', prop: 'courseCommentChildNums', width: 120, align: 'center', slot: 'courseCommentChildNums' },
                { label: '评论时间', prop: 'createtime', width: 160, align: 'center', slot: 'createtime' },
                {
                    type: 'operation',
                    label: '操作',
                    prop: 'operation',
                    fixed: 'right',
                    width: 100,
                    buttons: [
                        { key: 'delete', text: '删除', icon: 'el-icon-delete' }
                    ]
                }
            ],
            tableEditable: false,
            formDatas: {
                courseTitle: '',
                currentPage: 1,
                pageSize: 20,
            },
            totalCount: 0,
        };
    },
    created() {
        this.windheight = this.$store.state.windheight;
        this.tableHeight = this.windheight - 280 - this.windheight * 0.04;
        this.partserch();
    },
    mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.$nextTick(() => {
                const cardContent = this.$el.querySelector('.card-content');
                if (cardContent) {
                    this.tableHeight = this.$utils.getContainerAvailableHeight(cardContent, { extraOffset: 300 });
                }
            });
        },
        // 格式化时间
        formatTime(time) {
            if (!time) return '-';
            const date = new Date(time);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
        // 点击课程名称
        handleCourseClick(row) {
            this.$message.info(`课程ID: ${row.courseId}`);
        },
        // 查看子评论
        viewChildComments(row) {
            this.currentParentComment = row;
            this.loadChildComments(row);
            this.childCommentDialogVisible = true;
        },
        // 加载子评论
        loadChildComments(parentComment) {
            const params = {
                courseId: parentComment.courseId,
                courseCommentParentId: parentComment.courseCommentId
            };
            getAjCourseCommentList(params).then(res => {
                if (res.status === 200 && res.data) {
                    this.childComments = Array.isArray(res.data) ? res.data : (res.data.rows || []);
                }
            }).catch(err => {
                console.error('加载子评论失败:', err);
                this.childComments = [];
            });
        },
        // 分页变化
        handlePageChange({ currentPage, pageSize }) {
            this.formDatas.currentPage = currentPage;
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        // 操作按钮点击
        handleOperateBtnClick({ btn, row }) {
            switch (btn.key) {
                case 'delete':
                    this.deleteComment(row);
                    break;
            }
        },
        // 删除评论
        async deleteComment(row) {
            try {
                await this.$confirmDialog({
                    content: '确认删除该评论吗？',
                    type: 'danger'
                });
                deleteAjCourseComment({ courseCommentId: row.courseCommentId }).then(res => {
                    if (res.status === 200) {
                        this.$message.success('删除成功');
                        this.partserch();
                        // 如果子评论弹窗打开中，刷新子评论
                        if (this.childCommentDialogVisible && this.currentParentComment) {
                            this.loadChildComments(this.currentParentComment);
                        }
                    } else {
                        this.$message.error('删除失败');
                    }
                });
            } catch {
                this.$message.info('取消删除');
            }
        },
        // 查询列表
        partserch() {
            getAjCourseCommentListOperation(this.formDatas).then((res) => {
                if (res.status === 200) {
                    this.tableData = res.data || [];
                    this.totalCount = res.total || 0;
                }
            });
        },
    },
};
</script>

<style scoped>
/* 页面主布局样式 */
.bento-container {
    padding: 15px 20px;
    height: calc(100vh - 60px);
    width: 100%;
    max-width: 100%;
    background: linear-gradient(135deg, #f0f4ff 0%, #e8eeff 100%);
    box-sizing: border-box;
    overflow-y: auto;
    animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Page Header */
.bento-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding: 24px 28px;
    background: linear-gradient(135deg, #ffffff 0%, #fafbff 100%);
    border-radius: 20px;
    box-shadow: 0 4px 20px rgba(139, 92, 246, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(139, 92, 246, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.bento-header:hover {
    box-shadow: 0 6px 28px rgba(139, 92, 246, 0.12), 0 3px 12px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
}

.header-content {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-icon {
    width: 56px;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #ec4899 0%, #be185d 100%);
    border-radius: 16px;
    color: white;
    font-size: 28px;
    box-shadow: 0 8px 16px rgba(236, 72, 153, 0.3);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.header-icon:hover {
    transform: rotate(5deg) scale(1.05);
    box-shadow: 0 12px 24px rgba(236, 72, 153, 0.4);
}

.header-text h2 {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    color: #1e293b;
    background: linear-gradient(135deg, #1e293b 0%, #475569 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.header-text p {
    margin: 6px 0 0;
    font-size: 14px;
    color: #64748b;
    letter-spacing: 0.3px;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.header-search {
    flex: 1;
    max-width: 220px;
}

/* AI Button Styles */
.ai-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 11px 20px;
    border: none;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: linear-gradient(135deg, #ec4899 0%, #be185d 100%);
    color: white;
    box-shadow: 0 6px 20px rgba(236, 72, 153, 0.35);
    position: relative;
    overflow: hidden;
}

.ai-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.5s;
}

.ai-btn:hover::before {
    left: 100%;
}

.ai-btn:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 28px rgba(236, 72, 153, 0.45);
}

.ai-btn:active {
    transform: translateY(-1px);
    box-shadow: 0 4px 16px rgba(236, 72, 153, 0.3);
}

/* Bento Grid */
.bento-grid {
    grid-template-columns: 1fr;
    gap: 20px;
}

/* Bento Card */
.bento-card {
    background: linear-gradient(135deg, #ffffff 0%, #fefeff 100%);
    border-radius: 20px;
    padding: 24px;
    box-shadow: 0 4px 20px rgba(139, 92, 246, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(139, 92, 246, 0.08);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
}

.bento-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #ec4899, #be185d, #ec4899);
    background-size: 200% 100%;
    opacity: 0;
    transition: opacity 0.3s;
}

.bento-card:hover::before {
    opacity: 1;
    animation: shimmer 2s infinite;
}

@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }
    100% {
        background-position: 200% 0;
    }
}

.bento-card:hover {
    box-shadow: 0 8px 32px rgba(139, 92, 246, 0.15), 0 4px 16px rgba(0, 0, 0, 0.08);
    transform: translateY(-4px);
    border-color: rgba(139, 92, 246, 0.2);
}

.bento-card.full {
    width: 100%;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 2px solid #f1f5f9;
    position: relative;
}

.card-header::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 60px;
    height: 2px;
    background: linear-gradient(90deg, #ec4899, #be185d);
    border-radius: 2px;
}

.card-title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 17px;
    font-weight: 700;
    color: #1e293b;
}

.card-title i {
    color: #ec4899;
    font-size: 20px;
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.7;
    }
}

.ai-hint {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #ec4899;
    padding: 6px 14px;
    background: linear-gradient(135deg, #fdf2f8 0%, #fce7f3 100%);
    border-radius: 20px;
    border: 1px solid rgba(236, 72, 153, 0.2);
    transition: all 0.3s;
}

.ai-hint:hover {
    background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%);
    transform: scale(1.05);
}

/* Search Input */
.search-input-wrapper {
    position: relative;
}

.input-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    z-index: 1;
    font-size: 16px;
    transition: all 0.3s;
}

.search-input-wrapper:hover .input-icon {
    color: #ec4899;
    transform: translateY(-50%) scale(1.1);
}

.ai-input ::v-deep .el-input__inner {
    padding-left: 42px;
    border-radius: 12px;
    border: 2px solid #e2e8f0;
    background: #f8fafc;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    font-size: 14px;
    height: 42px;
}

.ai-input ::v-deep .el-input__inner:hover {
    border-color: #cbd5e1;
    background: white;
}

.ai-input ::v-deep .el-input__inner:focus {
    border-color: #ec4899;
    background: white;
    box-shadow: 0 0 0 4px rgba(236, 72, 153, 0.12);
    transform: translateY(-1px);
}

/* Table Styles */
.table-card {
    width: 100%;
    max-width: 100%;
    min-height: 400px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.card-content {
    padding: 4px 0;
}

/* Comment Content */
.comment-content {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.child-count {
    cursor: pointer;
    color: #ec4899;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 100%;
}

.child-count:hover {
    text-decoration: underline;
}

.no-child {
    color: #cbd5e1;
}

/* Parent Comment in Dialog */
.parent-comment {
    padding: 12px 16px;
    background: #f8fafc;
    border-radius: 8px;
    margin-bottom: 16px;
}

.parent-label {
    font-size: 12px;
    color: #64748b;
    margin-bottom: 8px;
}

.parent-content {
    color: #1e293b;
    font-size: 14px;
    line-height: 1.6;
}

/* 强制表格内容居中 */
::v-deep .el-table .cell {
    text-align: center !important;
}

::v-deep .el-table__header .cell {
    text-align: center !important;
}
</style>
